import React from 'react';
import { Pagination as PaginationNew } from './Pagination';
import { convertOldPaginationProps } from './converter.old';
import type { OldPaginationProps } from './converter.old';

export type PaginationProps = OldPaginationProps;

export const Pagination: React.FC<PaginationProps> = (props) => <PaginationNew {...convertOldPaginationProps(props)} />;
